import { render, staticRenderFns } from "./AccountAds.vue?vue&type=template&id=30222656&"
import script from "./AccountAds.vue?vue&type=script&lang=js&"
export * from "./AccountAds.vue?vue&type=script&lang=js&"
import style0 from "./AccountAds.vue?vue&type=style&index=0&id=30222656&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports